import React from 'react';
import {
  AutocompleteMultiSelect,
  AutocompleteMultiSelectProps,
  AutocompleteTagsSelectProps,
  IntegrationIcon,
  JupiterTheme,
  useSnackbarNotification,
} from '@jupiterone/jupiter-web-toolkit/src';
import { makeStyles, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    inputBox: {
      position: 'relative',
    },
  })
);

const AutocompleteTagsSelect = ({
  disabled,
  selectedTags,
  onChange,
  items,
}: AutocompleteTagsSelectProps) => {
  const classes = useStyles();
  const notificationManager = useSnackbarNotification();

  const handleChange: AutocompleteMultiSelectProps['onChange'] = (
    event,
    values
  ) => {
    event.stopPropagation();
    try {
      onChange(values);
    } catch (err) {
      notificationManager.error({
        message: 'Failed to select tag',
        error: err,
      });
    }
  };

  return (
    <AutocompleteMultiSelect
      className={classes.inputBox}
      disabled={disabled}
      refetchable
      getDecorationForItem={(item) => (
        <IntegrationIcon
          integrationTitle={getTitleForIcon(item.title)}
          size={20}
          style={{ stroke: 'black', strokeOpacity: 1 }}
        />
      )}
      items={items}
      value={selectedTags}
      onChange={handleChange}
      oneLine={true}
    />
  );
};

export default AutocompleteTagsSelect;

const getTitleForIcon = (name: string) => {
  let title = '';
  if (name.toLowerCase().startsWith('aws')) {
    title = 'AWS';
  } else if (name.toLowerCase().includes('gcp')) {
    title = 'Google Cloud';
  } else if (name.toLowerCase().includes('azure')) {
    title = 'Azure';
  } else {
    title = 'Custom';
  }
  return title;
};
